// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact-module--contact--3kExh","icons":"contact-module--icons--13c-Z","brand":"contact-module--brand--1FIsB","rest":"contact-module--rest--1KV0U"};